export function extractYouTubeId(url) {
  if (!url) return null;
  const p = /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
  const m = url.match(p);
  return m ? m[1] : null;
}

export function absoluteFileUrl(urlOrPath) {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  return `${process.env.REACT_APP_BACKEND_URL}${urlOrPath}`;
}

export const POPULAR_CITIES = [
  "Bangalore", "Chennai", "Delhi", "Hyderabad", "Kolkata",
  "Mumbai", "Pune", "Ahmedabad", "Jaipur", "Kochi",
  "Lucknow", "Chandigarh", "London", "New York", "Toronto", "Singapore", "Dubai",
];

export function fmtDuration(sec) {
  if (!sec) return "";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}
